module.exports = __webpack_public_path__ + "static/media/logo_dark.ace2ca97.svg";